var React = require('react');

function BugerIconClose (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"#040000","strokeMiterlimit":"10","x1":"26.216","y1":"0.451","x2":"0.216","y2":"12.938","key":0}),React.createElement("line",{"fill":"none","stroke":"#040000","strokeMiterlimit":"10","x1":"26.216","y1":"12.938","x2":"0.216","y2":"0.451","key":1})]));
}

BugerIconClose.defaultProps = {"version":"1.1","id":"圖層_1","x":"0px","y":"0px","width":"26.433px","height":"13.389px","viewBox":"0 0 26.433 13.389","enableBackground":"new 0 0 26.433 13.389","xmlSpace":"preserve"};

module.exports = BugerIconClose;

BugerIconClose.default = BugerIconClose;
